export const ACCOUNT_SNAPSHOT = 'ACCOUNT_SNAPSHOT';

export const ORG_LAYOUTS = {
  DESKTOP: [{ i: ACCOUNT_SNAPSHOT, x: 0, y: 0, w: 12, h: 9 }],
  TABLET: [{ i: ACCOUNT_SNAPSHOT, x: 0, y: 0, w: 12, h: 9 }],
  PHONE: [{ i: ACCOUNT_SNAPSHOT, x: 0, y: 0, w: 12, h: 9 }],
};
